import { IFacilityGroup } from 'common/src/types/interfaces';

import { textInputType } from '../../../common/forms/FormFieldTypes';

export const defaultValues = (entity: Partial<IFacilityGroup>) => ({
  name: entity.name ?? '',
  description: entity.description ?? '',
});

export const getFields = () => {
  const formFieldsConfiguration: Array<textInputType> = [
    {
      label: 'Group Name',
      name: 'name',
      type: 'textInput',
      placeholder: 'Group Name',
      required: true,
    },
    {
      name: 'description',
      placeholder: 'Notes',
      label: 'Notes',
      type: 'textInput',
      required: false,
      multiline: true,
    },
  ];
  return formFieldsConfiguration;
};
